import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3673 20.9065C21.0822 16.1396 23.0803 10.5571 21.5123 6.74181C20.7455 4.87608 19.1387 3.5441 17.2498 3.1331C15.5323 2.75939 13.639 3.15871 12 4.50767C10.3609 3.15871 8.46761 2.75939 6.75011 3.13311C4.86126 3.5441 3.25442 4.87609 2.48768 6.74183C0.919735 10.5572 2.91779 16.1396 11.6329 20.9065C11.8608 21.0312 12.1392 21.0312 12.3673 20.9065Z"
  })));
};

export { SvgHeartFilled as ReactComponent };
//# sourceMappingURL=heart--filled.svg.js.map
